import isLocale from 'validator/lib/isLocale';
// localeUtilRaw가 COMMON Module 방식이기 때문에 별도 require처리 필요
const localeUtil = { validate: isLocale }

export const DEFAULT_VALUES = {
    locale: 'en_US',
    '3rdLibsRootDir': ''
}

export const transformers = {
    locale: (value) => {
        const targetValue = value || ''
        const [languageCode, countryCode] = targetValue.replace('_', '-').split('-')
        if (!languageCode || !countryCode) {
            return DEFAULT_VALUES['locale']
        }
        
        const localeFormat = [languageCode.toLowerCase(), countryCode.toUpperCase()].join('-')
        return localeUtil.validate(localeFormat) ? localeFormat.replace('-', '_') : DEFAULT_VALUES['locale']
    },
    '3rdLibsRootDir': (value) => {
        if (!value) {
            return ''
        }
        return value
    }
}

export const getValidValue = (key, expectedValue) => {
    const transformAction = transformers[key] || ((value) => value)
    return transformAction(expectedValue) || DEFAULT_VALUES[key] || expectedValue
}

export default {
    DEFAULT_VALUES,
    transformers,
    getValidValue
}